import Axios from "axios";
import qs from "qs";
import { Message } from "element-ui";
import { GetQueryString } from "./common";
if (process.env.NODE_ENV === "production") {
  Axios.defaults.withCredentials = "include"; // 指示是否跨站点访问控制请求
  Axios.defaults.baseURL = "/api/";
} else {
  // Axios.defaults.baseURL = 'https://result.eolinker.com/wjEM1r7f5520d85514ca1281525118ca0e7223341d7c896?uri='
  Axios.defaults.baseURL = "http://127.0.0.1:8084/api";
  // Axios.defaults.baseURL = 'http://ueclub.kingdee.com'
}
Axios.timeout = 30000; // 设置超时时间
Axios.defaults.transformRequest = [
  function (data) {
    data = qs.stringify(data);
    console.log(data);
    return data;
  },
];
// http request拦截器通过这个我们就可以把token传到后台，拦截请求
Axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    const redirectUrl =
        encodeURIComponent(location.href.split("?")[0]) || location.href,
      ticket = GetQueryString("ticket"),
      auth_code = GetQueryString("auth_code");

    // if(config.url.indexOf('kux') > -1) {
    let headers = {
      redirectUrl: redirectUrl,
      ticket: ticket,
      "auth-code": auth_code,
    };
    config.headers = Object.assign(config.headers, headers);
    // }
    config.timeout = 30000;
    if (config.url.indexOf("vodreport.qcloud.com") > -1) {
      config.withCredentials = false;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor 拦截响应
Axios.interceptors.response.use(
  function (response) {
    if (response.data.errcode === 302 || response.data.isyun === "1") {
      location.href = response.data.url;
    }
    if (response.data.errcode === 6001) {
      // 未登录
      Message({
        // showClose: true,
        message:
          response.data.message ||
          response.data.description ||
          "请您先行登录您的账户!",
        type: "warning",
      });
      setTimeout(() => {
        location.href =
          "https://kui.kingdee.com/yzjlogin/?redirect_uri=" +
          encodeURIComponent(window.location.origin + window.location.pathname);
      }, 1500);
      return;
    } else if (response.data.errcode === 6003) {
      // 未登录
      Message({
        // showClose: true,
        message:
          response.data.message ||
          response.data.description ||
          "无法显示文章，您的账户可能没有查看权限。",
        type: "warning",
      });
      setTimeout(() => {
        location.href = "/";
      }, 1500);
      return;
    }

    if (response.data.errcode === 6002) {
      // 重新刷新
      location.reload();
      return;
    }
    return response;
  },
  function (error) {
    // Do something with response error
    Message.error("服务器请求失败！");
    return Promise.reject(error);
  }
);

export default Axios;
